import React, { createContext, useContext, useState } from "react";

const CancelRequestContext = createContext(null);

export const useCancelRequest = () => useContext(CancelRequestContext);

export const CancelRequestProvider = ({ children }) => {
  const [cancelRequest, setCancelRequest] = useState(null);

  return (
    <CancelRequestContext.Provider value={{ cancelRequest, setCancelRequest }}>
      {children}
    </CancelRequestContext.Provider>
  );
};
